import React from 'react';
import PropTypes from 'prop-types';
import { Button } from '@els/els-react--button';

function ExportModalFooter({ isFormAcceptable, apply }) {
  return (
    <div className="exportModal__footer">
      <div className="exportModal__footer_buttons">
        <Button
          data-e2e="export-modal-apply"
          type="primary"
          size="small"
          onClick={apply}
          disabled={!isFormAcceptable}
          className="e2e-export-modal-apply">
          Export
        </Button>
      </div>
    </div>
  );
}

ExportModalFooter.propTypes = {
  isFormAcceptable: PropTypes.bool,
  apply: PropTypes.func.isRequired,
};

export default ExportModalFooter;
